import { GsbUser } from './gsb-user.model';
import { GsbModule } from './gsb-module.model';
import { GsbFile } from './gsb-file.model';
import { GsbMlContent } from './gsb-ml-content.model';
import { GsbCategory } from './gsb-category.model';
import { GsbTag } from './gsb-tag.model';

/**
 * Document template model
 */
export interface GsbDocTemplate {
  thumbnail_id?: string;
  fileName?: string;
  createdBy?: GsbUser;
  name?: string;
  module?: GsbModule;
  categories?: GsbCategory[];
  mlContent_id?: string;
  html?: string;
  createDate?: Date;
  title?: string;
  lastUpdatedBy?: GsbUser;
  isMultilingual?: boolean;
  module_id?: string;
  mlContent?: GsbMlContent;
  languageScript?: string;
  thumbnail?: GsbFile;
  tags?: GsbTag[];
  test?: string;
  createdBy_id?: string;
  defaultPrintOptions?: string;
  lastUpdateDate?: Date;
  enableOverride?: boolean;
  lastUpdatedBy_id?: string;
  
  // Add a templateType field for filtering
  templateType?: string;
} 